var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUserHighlighted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-highlighted",
    transform: "translate(-1793 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21152",
    "data-name": "Group 21152",
    transform: "translate(1793 282)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_896",
    "data-name": "Ellipse 896",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    transform: "translate(1804.966 292.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M0,72.117V75.97H3.853l9.517-9.517L9.477,62.64Z",
    transform: "translate(0 -59.623)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M220.7,4.154a1.03,1.03,0,0,0,0-1.454L218.3.3a1.03,1.03,0,0,0-1.454,0l-1.88,1.88,3.853,3.853,1.88-1.88Z",
    transform: "translate(-204.616)",
    fill: "#505465"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserHighlighted);
export default __webpack_public_path__ + "static/media/EditUser-highlighted.b3f7ce5645cfd0803ae1c1336e7f8cf1.svg";
export { ForwardRef as ReactComponent };